/* eslint-disable */
import React from 'react'
import { Row, Col } from 'antd'
import YouTube from 'react-youtube'
import MenuContainer from '../../components/menu'
import {
  Wrapper, Image,
} from '../content/styled'
import { P } from './styled'
import { H2, H3, P as CommonP } from '../../components/common/text'

export default class Continer extends React.PureComponent {
  render() {
    return (
      <div>
        <MenuContainer solid={true} />
        <Row justify='center' type='flex' style={{ padding: '55px 0' }}>
          <Col xs={20} lg={18} xl={16}>
            <Row justify='center' type='flex'>
              <H2>อาการออฟฟิศซินโดรมและการยศาสตร์</H2>
            </Row>
            <OfficeSyndrome />
            <Ergonomics />
          </Col>
        </Row>
      </div>
    )
  }
}

const OfficeSyndrome = () => (
  <Wrapper>
    <Row justify='center' type='flex' style={{ marginBottom: 32 }}>
      <H3>อาการออฟฟิศซินโดรม</H3>
    </Row>
    <Row>
      <Col span={16} offset={4} style={{ marginBottom: 32 }}>
        <YouTube
          opts={{
            width: '100%',
            height: '481',
            playerVars: {
              rel: 0,
              loop: 1,
              playlist: 'F6Nwy4tv3HI',
            },
          }}
          videoId='F6Nwy4tv3HI'
        />
      </Col>
    </Row>
    <Row style={{ marginBottom: 32 }}>
      <Col span={24}>
        <P>ในปัจจุบันนี้ เครื่องคอมพิวเตอร์ตั้งโต๊ะ (Desktop computer) และเครื่องคอมพิวเตอร์พกพา (Notebook computer)  เป็นอุปกรณ์สำคัญที่ช่วยให้การปฏิบัติงานหลายประเภทในสำนักงานเป็นไปอย่างมีประสิทธิภาพและได้ผลสำเร็จโดยใช้เวลาที่สั้นลง พนักงานส่วนใหญ่ในสำนักงานใช้เครื่องคอมพิวเตอร์เป็นอุปกรณ์หลักในการปฏิบัติงานต่าง ๆ อย่างต่อเนื่อง  โดยที่ระยะเวลาในการปฏิบัติงานกับเครื่องคอมพิวเตอร์ในแต่ละวันมักจะนานกว่า 4 ชั่วโมง และถ้าเป็นพนักงานระดับปฏิบัติการ ก็ต้องปฏิบัติงานกับเครื่องคอมพิวเตอร์เป็นระยะเวลาไม่น้อยกว่า 6ชั่วโมงต่อวัน สถานีงานคอมพิวเตอร์ (โต๊ะและเก้าอี้) ที่พบในสำนักงานต่าง ๆ มักจะเป็นโต๊ะระดับเดียว (เช่น โต๊ะทำงาน) หรือโต๊ะคอมพิวเตอร์ (ที่มีลิ้นชักวางแป้นพิมพ์ซึ่งเลื่อนเข้า-ออกได้) ส่วนเก้าอี้จะเป็นเก้าอี้สำนักงานประเภทมีล้อเลื่อนและปรับระดับเบาะนั่งให้สูง-ต่ำได้ ซึ่งสถานีงานคอมพิวเตอร์เหล่านี้มีขีดจำกัดในด้านการปรับระดับสูง-ต่ำและระยะใกล้-ห่างให้เหมาะสมกับร่างกายของพนักงาน อุปกรณ์คอมพิวเตอร์ที่ใช้ปฏิบัติงานสำนักงานประกอบด้วยแป้นพิมพ์ เมาส์ และจอภาพ โดยที่จำนวนของจอภาพที่พนักงานบางคนใช้ อาจจะเป็น 2 จอภาพ ขึ้นอยู่กับลักษณะของงานที่ปฏิบัติ</P>
      </Col>
    </Row>
    <Row gutter={32} style={{ marginBottom: 50 }} type='flex' justify='center'>
      <Col xs={20} lg={16}>
        <Image src={require('../../images/office-syndrome/1.jpg')}/>
      </Col>
    </Row>
    <Row style={{ marginBottom: 32 }}>
      <Col span={24}>
        <P>ออฟฟิศซินโดรม คือ กลุ่มอาการของปัญหาสุขภาพและโรคต่าง ๆ ที่มักจะพบในพนักงานสำนักงาน ซึ่งเกิดจากการปฏิบัติงานกับเครื่องคอมพิวเตอร์ด้วยท่าทางหรือพฤติกรรมที่ไม่เหมาะสม (เช่น ปฏิบัติงานในท่าทางที่ไม่ถูกต้อง นั่งในท่าเดิมโดยไม่เปลี่ยนอิริยาบถเป็นระยะเวลานานเกินไป ทำงานกับเครื่องคอมพิวเตอร์อย่างต่อเนื่องโดยไม่หยุดพัก) ภายใต้สภาพแวดล้อมที่ไม่เหมาะสม (เช่น สถานที่ทำงานมีเสียงดังรบกวนการทำงาน ระดับแสงสว่างที่บริเวณทำงานไม่พอเพียง มีแสงสะท้อนบนจอภาพจากไฟเพดานหรือจากแสงสว่างภายนอก อุณหภูมิร้อนหรือเย็นเกินไป) และการใช้อุปกรณ์ปฏิบัติงานที่ไม่เหมาะสม (เช่น เก้าอี้นั่งมีเบาะที่มีความลึกมากเกินไป ที่พักแขนปรับระดับไม่ได้ โต๊ะวางเครื่องคอมพิวเตอร์ไม่มีลิ้นชักวางแป้นพิมพ์)</P>
      </Col>
    </Row>
    <Row gutter={32} style={{ marginBottom: 50 }} type='flex' justify='center'>
      <Col xs={20} lg={16}>
        <CommonP>ตัวอย่างกลุ่มอาการออฟฟิศซินโดรม คือ</CommonP>
        <Image src={require('../../images/office-syndrome/2.jpg')} margin='15px 0' />
      </Col>
      <Col span={24}>
        <P>1.&nbsp;&nbsp;กลุ่มปัญหาที่พบในระบบกล้ามเนื้อและกระดูก (Musculoskeletal System) ของร่างกาย ได้แก่ อาการปวดเมื่อยและบาดเจ็บที่ส่วนต่าง ๆ ของร่างกาย เช่น คอ ไหล่ ข้อมือ หลัง (ส่วนล่าง) ขา เท้า </P>
      </Col>
    </Row>
    <Row gutter={32} style={{ marginBottom: 50 }} type='flex' justify='center'>
      <Col xs={20} lg={16}>
        <Image src={require('../../images/office-syndrome/3.jpg')} margin='15px 0' />
      </Col>
      <Col span={24}>
        <P>2.&nbsp;&nbsp;กลุ่มปัญหาที่พบในระบบการมองเห็น เช่น อาการปวดเมื่อยกล้ามเนื้อตา อาการตาแห้ง อาการตาพร่ามัว และอาการวุ้นในลูกตาเสื่อม</P>
      </Col>
    </Row>
    <Row gutter={32} style={{ marginBottom: 50 }} type='flex' justify='center'>
      <Col xs={20} lg={16}>
        <Image src={require('../../images/office-syndrome/4.jpg')} margin='15px 0' />
      </Col>
      <Col span={24}>
        <P>3.&nbsp;&nbsp;กลุ่มปัญหาด้านจิตใจ เช่น อาการเครียด กังวล นอนไม่หลับ</P>
      </Col>
    </Row>
    <Row gutter={32} style={{ marginBottom: 50 }} type='flex' justify='center'>
      <Col xs={20} lg={16}>
        <Image src={require('../../images/office-syndrome/5.jpg')} margin='15px 0' />
      </Col>
      <Col span={24}>
        <P>4.&nbsp;&nbsp;กลุ่มปัญหาสุขภาพอื่น ๆ เช่น กระเพาะปัสสาวะอักเสบ ความดันโลหิตสูง น้ำหนักตัวเพิ่ม ปวดศีรษะเรื้อรัง กรดไหลย้อน</P>
      </Col>
    </Row>
    <Row>
      <Col span={24}>
        <P>ในกลุ่มอาการออฟฟิศซินโดรมที่กล่าวมาในข้างต้น กลุ่มปัญหาที่พบในระบบกล้ามเนื้อและกระดูกของร่างกายเป็นกลุ่มปัญหาที่เด่นชัดและปรากฎในพนักงานสำนักงานจำนวนมากทั้งผู้ชายและผู้หญิง ซึ่งเป็นผลกระทบด้านสุขภาพโดยตรงต่อส่วนต่าง ๆ ของร่างกายเนื่องจากการปฏิบัติงานกับเครื่องคอมพิวเตอร์</P>
      </Col>
    </Row>
  </Wrapper>
)

const Ergonomics = () => (
  <Wrapper>
    <Row justify='center' type='flex' style={{ marginBottom: 32 }}>
      <H3>การยศาสตร์</H3>
    </Row>
    <Row style={{ marginBottom: 32 }}>
      <Col span={24}>
        <P>นักวิจัยทางด้านการยศาสตร์และด้านอาชีวอนามัยและความปลอดภัยได้รายงานว่า พนักงานที่ปฏิบัติงานกับเครื่องคอมพิวเตอร์ในสำนักงาน และมีปัญหาอาการบาดเจ็บสะสมที่ระบบกล้ามเนื้อและกระดูก (Musculoskeletal Disorders, MSDs) มีจำนวนเพิ่มขึ้นทุกปี โดยนักวิจัยได้สรุปว่าสาเหตุหลักประการหนึ่งของปัญหานี้ คือ การปฏิบัติงานกับเครื่องคอมพิวเตอร์อย่างไม่ถูกต้องตามหลักการยศาสตร์ ซึ่งทำให้เกิดผลกระทบต่อสุขภาพของพนักงาน โดยจะมีอาการปวดเมื่อย (รวมทั้งบาดเจ็บ) ที่ส่วนต่าง ๆ ของร่างกาย เช่น บริเวณคอ ไหล่ ข้อมือ และหลัง (ส่วนล่าง) และจะมีผลกระทบต่อสมรรถภาพในการปฏิบัติงานของพนักงานด้วย</P>
      </Col>
    </Row>
    <Row style={{ marginBottom: 32 }}>
      <Col span={24}>
        <P>การยศาสตร์ (Ergonomics) คือ สหวิทยาการที่ศึกษาเกี่ยวกับระบบงานซึ่งมีองค์ประกอบสำคัญ คือ มนุษย์ อุปกรณ์และเครื่องมือ สภาพแวดล้อม และงานที่ต้องปฏิบัติ โดยมีจุดมุ่งหมายที่จะช่วยออกแบบ ดัดแปลง และปรับปรุงระบบงานให้เกิดความเหมาะสมสำหรับมนุษย์ เพื่อให้สามารถปฏิบัติงานได้อย่างมีประสิทธิภาพสูงสุดและได้รับผลกระทบจากองค์ประกอบอื่น ๆ น้อยที่สุด  ในระบบงานการยศาสตร์ องค์ประกอบต่าง ๆ ของระบบงานมีปฏิสัมพันธ์กันตลอดเวลา นักการยศาสตร์ต้องพิจารณามนุษย์เป็นองค์ประกอบที่สำคัญที่สุด (หรือเป็นศูนย์กลาง) ของระบบงาน และต้องออกแบบ ดัดแปลง และปรับปรุงองค์ประกอบอื่น ๆ ให้สอดคล้องกับและส่งเสริมองค์ประกอบมนุษย์</P>
      </Col>
    </Row>
    <Row gutter={32} style={{ marginBottom: 50 }} type='flex' justify='center'>
      <Col xs={20} lg={16}>
        <Image src={require('../../images/office-syndrome/6.jpg')}/>
      </Col>
    </Row>
    <Row style={{ marginBottom: 32 }}>
      <Col span={24}>
        <P>ในระบบงานซึ่งมีพนักงานนั่งปฏิบัติงานกับเครื่องคอมพิวเตอร์ในสำนักงาน ก็สามารถพิจารณาเป็นระบบงานการยศาสตร์ได้ ดังนั้น การนำหลักการยศาสตร์ไปประยุกต์ใช้เพื่อปรับปรุงการปฏิบัติงานกับเครื่องคอมพิวเตอร์ จะต้องพิจารณาองค์ประกอบต่าง ๆ ของระบบงานในสำนักงาน คือ สถานีงาน (โต๊ะและเก้าอี้) อุปกรณ์คอมพิวเตอร์ (แป้นพิมพ์ เมาส์ และจอภาพ) สภาพแวดล้อม งาน และพฤติกรรมของพนักงาน นักการยศาสตร์ต้องประเมินระบบงานคอมพิวเตอร์ในสำนักงานตามหลักการยศาสตร์ และประเมินท่าทางในการปฏิบัติงานของพนักงานด้วย ผลจากการประเมิน  ระบบงานและท่าทางของพนักงาน จะช่วยให้นักการยศาสตร์ทราบสาเหตุของปัญหาอาการปวดเมื่อยที่ส่วนต่าง ๆ ของร่างกาย และสามารถเสนอแนะวิธีการแก้ไขปัญหาได้อย่างถูกต้องและเหมาะสม การที่มีนักการยศาสตร์ไปช่วยประเมินระบบงานคอมพิวเตอร์ในสำนักงาน จะช่วยลดความเสี่ยงต่อการเกิดปัญหาอาการบาดเจ็บสะสมที่ระบบกล้ามเนื้อและกระดูกได้ ซึ่งจะช่วยเอื้ออำนวยให้คุณภาพของชีวิตการทำงานดีขึ้น พนักงานสามารถปฏิบัติงานที่ได้รับมอบหมายอย่างสะดวกสบายขึ้น และองค์กรได้ผลงานที่สำเร็จสมบูรณ์มากขึ้น</P>
      </Col>
    </Row>
  </Wrapper>
)